import Vue from 'vue';
import Router from 'vue-router';
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin, AmplifyEventBus } from 'aws-amplify-vue';
import _ from 'lodash';

import {
  AuthOneLogin,
  Profile,
  Dashboard,
  MyApplication,
  NotAllowed,
  Users,
  UserDetail,
  OnboardingUsers,
  OnboardingUserDetail,
  Registrations,
  TemplateTypes,
  Templates,
  Emails,
  EmailDetail,
  BaaderDetail,
  SecondaryMarketOrders,
  AccountCreations,
  OrderItems,
  PayoutItems,
  Assets,
  AccountDetail,
  Accounts,
  Securities,
  BlockchainOrders,
  VaultTransactions,
  VaultWallets,
  VaultAssets,
  Trades,
  BaaderbankConfirmTradesView,
  BlockchainPendingTrades,
  CancellableTradesView,
  SellOffers,
  BuyOffers,
  EmoneyUsers,
  SignIn,
  SignUp,
  SignUpConfirm,
  ResetPassword,
  IdentView,
  BridgeSigningView,
  DigitalDepotDLQView,
  StrategiesSettlementView,
  CanceledSettlements,
  StrategiesTrancheUtilizationView,
  DigitalDepotAccountsView,
  DdAccountsView,
  PayoutsAndTaxesTaxTraitsView,
  PayoutsAndTaxesSecuritiesView,
  PayoutsAndTaxesPayoutsView,
  PayoutsAndTaxesPaybacksView,
  PayoutsAndTaxesPaybackDetailView,
  PayoutsAndTaxesManagementView,
  PayoutsAndTaxesReportingView,
  PayoutsAndTaxesHistoryView,
  FinancialProducts,
  FinancialProductExpose,
  Files,
  FinancialProductDetails,
  RoboInvestingSavingPlans,
  RoboInvestingFpvReports,
  IpSignings,
  DirectSignings,
  IreDLQView,
  EieInvestments,
  EieAssetsView,
} from '@/views';

import apiEnv from '@/enum/apiEnv';
import { getUser, getPreferredMFA, signOut } from '@/utils/auth';

Vue.use(Router);
Vue.use(AmplifyPlugin, AmplifyModules);

export const ROLE_GROUPS = {
  SUPER_ADMIN: 'super-admin',
  ADMIN_BACKEND: 'admin-backend',
  ADMIN_ONBOARDING: 'admin-onboarding',
  ADMIN_IDENT: 'admin-ident',
  ADMIN_BAADER: 'admin-baader',
  ADMIN_MAIL: 'admin-mail',
  ADMIN_BLOCKCHAIN: 'admin-blockchain',
  ADMIN_TRADING: 'admin-trading',
  ADMIN_VAULT: 'admin-vault',
  ADMIN_EMONEY: 'admin-emoney',
  ADMIN_FINANCIAL: 'admin-financial',
  ADMIN_IRE: 'admin-ire',
  ADMIN_STRATEGIES: 'admin-strategies',
  ADMIN_PAT: 'admin-pat',
  ADMIN_EIE: 'admin-eie',
};

let authenticatonType = '';

AmplifyEventBus.$on('authState', async (state) => {
  const type = authenticatonType;

  const pushPathes = {
    signedOut: () => {
      router.push({ path: '/login', query: authenticatonType ? { type } : null });
    },
    signUp: () => {
      router.push({ path: '/register', query: authenticatonType ? { type } : null });
    },
    confirmSignUp: () => {
      router.push({ path: '/confirm-register', query: authenticatonType ? { type } : null });
    },
    signIn: () => {
      router.push({ path: '/login', query: authenticatonType ? { type } : null });
    },
    signedIn: () => {
      router.push({ path: '/' });
    },
  };

  if (typeof pushPathes[state] === 'function') {
    pushPathes[state]();
  }
});

const scrollableElementId = 'mainContainer';
const scrollPositions = Object.create(null);

const router = new Router({
  routes: [
    /**
     * Authentication routes
     */
    {
      path: '/auth-one-login',
      name: 'AuthOneLogin',
      component: AuthOneLogin,
      meta: { requiresAuth: false },
    },

    /**
     * Unauthenticated routes
     */

    {
      path: '/login',
      name: 'Login',
      component: SignIn,
      meta: { requiresAuth: false },
    },
    {
      path: '/register',
      name: 'Register',
      component: SignUp,
      meta: { requiresAuth: false },
    },
    {
      path: '/confirm-register',
      name: 'ConfirmRegister',
      component: SignUpConfirm,
      meta: { requiresAuth: false },
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: { requiresAuth: false },
    },
    /**
     * Authenticated routes
     * meta: { requiresAuth: true }
     */
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: { requiresAuth: true },
    },
    // Dashboard
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: { requiresAuth: true },
    },
    // MY APPLICATION
    {
      path: '/my-application',
      name: 'my_application',
      component: MyApplication,
      meta: { requiresAuth: true },
    },
    // USERS
    {
      path: '/users/onboarding-users',
      name: 'Onboarding Users',
      component: OnboardingUsers,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_ONBOARDING],
      },
    },
    {
      path: '/users/onboarding-users/:id',
      name: 'Onboarding User details',
      component: OnboardingUserDetail,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_ONBOARDING],
      },
    },
    {
      path: '/users/registrations',
      name: 'User Registrations',
      component: Registrations,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_BACKEND],
      },
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_BACKEND],
      },
    },
    {
      path: '/users/:id',
      name: 'user_detail',
      component: UserDetail,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_BACKEND],
      },
    },
    // EMAIL
    {
      path: '/template-types',
      name: 'Email Template Types',
      component: TemplateTypes,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_MAIL] },
    },
    {
      path: '/templates',
      name: 'Email Templates',
      component: Templates,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_MAIL] },
    },
    {
      path: '/emails',
      name: 'Emails',
      component: Emails,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_MAIL] },
    },
    {
      path: '/emails/:id/:mode',
      name: 'Email Detail',
      component: EmailDetail,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_MAIL] },
    },
    // BAADER BANK
    {
      path: '/baader/account-creations',
      name: 'account_creations',
      component: AccountCreations,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_BAADER] },
    },
    {
      path: '/baader/order-items',
      name: 'order_items',
      component: OrderItems,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_BAADER] },
    },
    {
      path: '/baader/payout-items',
      name: 'payout_items',
      component: PayoutItems,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_BAADER] },
    },
    {
      path: '/baader/assets',
      name: 'baader_assets',
      component: Assets,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_BAADER] },
    },
    {
      path: '/baader/secondary-market-orders',
      name: 'secondary_market_orders',
      component: SecondaryMarketOrders,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_BAADER] },
    },
    {
      path: '/baader/accounts',
      name: 'accounts',
      component: Accounts,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_BAADER] },
    },
    {
      path: '/baader/accounts/:snr',
      name: 'account_detail',
      component: AccountDetail,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_BAADER] },
    },
    {
      path: '/baader/:snr',
      name: 'baader_detail',
      component: BaaderDetail,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_BAADER] },
    },
    // SECURITIES
    {
      path: '/securities',
      name: 'securities',
      component: Securities,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_BAADER] },
    },
    // BLOCKCHAIN ORDERS
    {
      path: '/blockchain-orders',
      name: 'blockchain_orders',
      component: BlockchainOrders,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_BLOCKCHAIN],
      },
    },
    // BLOCKCHAIN PENDING TRANSFERS
    {
      path: '/trading-platform/trades',
      name: 'trades',
      component: Trades,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_TRADING],
      },
    },
    {
      path: '/vault/transactions',
      name: 'vault_transactions',
      component: VaultTransactions,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_VAULT],
      },
    },
    {
      path: '/vault/wallets',
      name: 'vault_wallets',
      component: VaultWallets,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_VAULT],
      },
    },
    {
      path: '/vault/assets',
      name: 'vault_assets',
      component: VaultAssets,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_VAULT],
      },
    },
    {
      path: '/trading-platform/trades-to-transfer',
      name: 'blockchain_pending_trades',
      component: BlockchainPendingTrades,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_TRADING],
      },
    },
    {
      path: '/trading-platform/baaderbank-confirm-trades',
      name: 'baaderbank_confirm_trades',
      component: BaaderbankConfirmTradesView,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_TRADING],
      },
    },
    {
      path: '/trading-platform/sell-offers',
      name: 'sell_offers',
      component: SellOffers,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_TRADING],
      },
    },
    {
      path: '/trading-platform/buy-offers',
      name: 'buy_offers',
      component: BuyOffers,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_TRADING],
      },
    },
    {
      path: '/trading-platform/cancellable-trades',
      name: 'cancellable_trades',
      component: CancellableTradesView,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_TRADING],
      },
    },
    // EMoney user MangoPay wallet and escrows
    {
      path: '/emoney-users',
      name: 'emoney-users',
      component: EmoneyUsers,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_EMONEY] },
    },
    // IDENT
    {
      path: '/ident-cases',
      name: 'ident',
      component: IdentView,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_IDENT] },
    },
    // IDENT
    {
      path: '/bridge-signing-management',
      name: 'bridge Signin Management',
      component: BridgeSigningView,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_IDENT] },
    },
    // Financial Products
    {
      path: '/financial-products/products',
      name: 'financial products products',
      component: FinancialProducts,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_FINANCIAL],
      },
    },
    {
      path: '/financial-products/product/:instrument/:securityIdType/:securityId',
      name: 'financial_product_detail',
      component: FinancialProductDetails,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_FINANCIAL],
      },
    },
    {
      path: '/financial-products/tranche/:instrument/:securityIdType/:securityId/:createdAt',
      name: 'tranche_detail',
      component: FinancialProductDetails,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_FINANCIAL],
      },
    },
    {
      path: '/financial-products/files',
      name: 'financial products files',
      component: Files,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_FINANCIAL],
      },
    },
    {
      path: '/financial-products/exposes',
      name: 'financial products exposes',
      component: FinancialProductExpose,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_FINANCIAL],
      },
    },
    // Investment Reporting Engine
    {
      path: '/ire/ip-signings',
      name: 'ire_ip_signings',
      component: IpSignings,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_IRE] },
    },
    {
      path: '/ire/direct-signings',
      name: 'ire_direct_signings',
      component: DirectSignings,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_IRE] },
    },
    {
      path: '/ire/dlq',
      name: 'ire_dlq',
      component: IreDLQView,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_IRE] },
    },
    // Digital Depots
    {
      path: '/dd/accounts',
      name: 'ddAccounts',
      component: DdAccountsView,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_STRATEGIES],
      },
    },
    {
      path: '/digitalDepots/accounts',
      name: 'Accounts',
      component: DigitalDepotAccountsView,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_STRATEGIES],
      },
    },
    {
      path: '/digitalDepots/dlq',
      name: 'Digital Depot DLQ Management',
      component: DigitalDepotDLQView,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_STRATEGIES],
      },
    },
    // Settlements
    {
      path: '/settlements',
      name: 'Strategies Settlement Management',
      component: StrategiesSettlementView,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_STRATEGIES],
      },
    },
    {
      path: '/settlements/canceled',
      name: 'Strategies Canceled Settlements Management',
      component: CanceledSettlements,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_STRATEGIES],
      },
    },
    {
      path: '/settlements/tranche',
      name: 'Strategies Tranche Utilization Management',
      component: StrategiesTrancheUtilizationView,
      meta: { requiresAuth: true },
    },
    // Robo Investing
    {
      path: '/robo-investing/savings-plans',
      name: 'robo-investing_saving_plans',
      component: RoboInvestingSavingPlans,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_IRE] },
    },
    {
      path: '/robo-investing/fpv-reports',
      name: 'robo-investing_fpv_reports',
      component: RoboInvestingFpvReports,
      meta: { requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_IRE] },
    },
    // Payout and Taxes
    {
      path: '/pat/payouts',
      name: 'Payouts',
      component: PayoutsAndTaxesPayoutsView,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_STRATEGIES],
      },
    },
    {
      path: '/pat/paybacks',
      name: 'Paybacks',
      component: PayoutsAndTaxesPaybacksView,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_STRATEGIES],
      },
    },
    {
      path: '/pat/payback/:payoutId',
      name: 'payback_view ',
      component: PayoutsAndTaxesPaybackDetailView,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_STRATEGIES],
      },
    },
    {
      path: '/pat/securities',
      name: 'Securities',
      component: PayoutsAndTaxesSecuritiesView,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_STRATEGIES],
      },
    },
    {
      path: '/pat/tax-traits',
      name: 'Tax Traits',
      component: PayoutsAndTaxesTaxTraitsView,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_STRATEGIES],
      },
    },
    {
      path: '/pat/management',
      name: 'Management',
      component: PayoutsAndTaxesManagementView,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_STRATEGIES],
      },
    },
    {
      path: '/pat/reporting',
      name: 'Reporting',
      component: PayoutsAndTaxesReportingView,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_STRATEGIES],
      },
    },
    {
      path: '/pat/history',
      name: 'History',
      component: PayoutsAndTaxesHistoryView,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_STRATEGIES],
      },
    },
    {
      path: '/eie/investments',
      name: 'EIE Investments',
      component: EieInvestments,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_EIE],
      },
    },
    {
      path: '/eie/assets',
      name: 'EIE Assets',
      component: EieAssetsView,
      meta: {
        requiresAuth: true, roleGroups: [ROLE_GROUPS.SUPER_ADMIN, ROLE_GROUPS.ADMIN_EIE],
      },
    },
    // Not Allowed Page
    {
      path: '/not_allowed',
      name: 'Not Allowed',
      component: NotAllowed,
      meta: { requiresAuth: true },
    },
    // default redirect
    {
      path: '/',
      name: 'Dashboard',
      redirect: '/dashboard',
    },
    // NOT FOUND
    {
      path: '*',
      redirect: '/',
    },
  ],

  scrollBehavior(to) {
    const currentRouteName = to.name;

    const element = document.getElementById(scrollableElementId);
    if (element !== null && currentRouteName in scrollPositions) {
      return new Promise((resolve) => {
        setTimeout(() => {
          element.scrollTop = scrollPositions[currentRouteName];
          resolve(element.scrollTop);
        }, 50);
      });
    }

    return null;
  },
});

router.beforeEach((to, from, next) => {
  if (to.redirectedFrom && to.redirectedFrom.indexOf('/id_token=') === 0) {
    // means we've been redirected from OneLogin with success,
    // we need to redirect to /#/auth-one-login to validate the token

    return next({ path: '/auth-one-login', query: { id_token: to.redirectedFrom.replace('/id_token=', '') } });
  }

  return next();
});

router.beforeResolve(async (to, from, next) => {
  authenticatonType = to.query.type ? to.query.type : '';

  if (to.query.env) {
    localStorage.setItem('Exporo.API.env', to.query.env);
    delete to.query.env;

    return next({ path: to.path, query: to.query });
  }

  let env = localStorage.getItem('Exporo.API.env');

  if (!env) {
    env = 'prod';
    localStorage.setItem('Exporo.API.env', env);
  }

  if (to.path === '/login' || from.name === null) {
    const apiEnvConfig = apiEnv[env];

    // SET COGNITO CONFIG
    Amplify.configure(apiEnvConfig.COGNITO_CONFIG);

    // SET BASE API URLS CONFIG
    window.BASE_API = apiEnvConfig.BASE_API;
    window.COGNITO_CONFIG = apiEnvConfig.COGNITO_CONFIG;
    window.ONELOGIN_CONFIG = apiEnvConfig.ONELOGIN_CONFIG;
    window.LANGUAGES = apiEnvConfig.LANGUAGES;
  }

  const user = await getUser();

  if (!user) {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      return next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else {
    const isProduction = env === 'prod';
    if (isProduction &&
      to.meta.roleGroups &&
      !_.some(to.meta.roleGroups, role => user.groups.includes(role))
    ) {
      return next({
        path: '/not_allowed',
      });
    }
    if (!user.origin) {
      const currentMFAType = await getPreferredMFA(user);

      if (from.path === '/login' && currentMFAType === 'NOMFA') {
        await signOut();

        return next({
          name: to.name,
          query: to.query,
        });
      }
    }

    if (to.matched.some(record => typeof (record.meta.requiresAuth) === 'boolean' && !record.meta.requiresAuth)) {
      return next({
        path: '/',
      });
    }
  }

  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js